import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { obtenerCamposFiltroPedidos, obtenerDatosFiltrosPedidos, obtenerPedidosPorEtapa } from '../../../../service/pedidos/Pedidos';
import { GenericoModel } from '../../../catalogos/generico/models/GenericoModel';


export const useObtenerPedidosPorEtapa = (actualizar: number, filtros: any) => {
  const [pedidos, setPedidos] = useState<any[]>([]);
  const [pedidosPorEtapa, setPedidosPorEtapa] = useState<any[]>([]);
  const [cargando, setCargando] = useState<boolean>(true);
  const history = useHistory();

  useEffect(() => {
    let isMounted = true; 
    const fetchTareas = async () => {
      setCargando(true);
      try {
        const res = await obtenerPedidosPorEtapa(filtros);
        if (res && isMounted) {
          setPedidos(res.pedidos);
          setPedidosPorEtapa(res.pedidosPorEtapa);
        }
      } catch (error) {
        if (isMounted) {
          history.push('/error/500');
        }
      } finally {
        if (isMounted) {
          setCargando(false);
        }
      }
    };
    
      fetchTareas();
    
    return () => {
      isMounted = false;
    };
  }, [actualizar, history]);

  return { pedidos, pedidosPorEtapa, cargando };
};


export const useObtenerCamposFiltroPedidos = (isAdmin: any) => {
  const [listFields, setListFields] = useState<GenericoModel[]>([]);
  const [loadingRequest, setLoadingRequest] = useState<boolean>(false);

  const history = useHistory();

  useEffect(() => {
    let isMounted = true;

    const fetchPost = async () => {
      setLoadingRequest(true);
      try {
        const res = await obtenerCamposFiltroPedidos();
        if (isMounted && res) {
          let filteredRes = res;
          // filteredRes = res.filter((option: any) => option.code !== "ORD_COB_FECHA_VENC" && option.code !== "ORD_COB_FECHA_FAC" && option.code !== "ORD_COB_FOLIO");

          // if (!isAdmin) {
          //   filteredRes = res.filter((option: any) => option.code !== "ORD_COB_USER");
          // }
          const selectOptions = filteredRes.map((option: any) => ({
            value: option.id,
            label: `${option.name}`,
            code: option.code,
          }));
          setListFields(selectOptions);
        }
      } catch (error) {
        history.push("/error/500");
      } finally {
        if (isMounted) {
          setLoadingRequest(false);
        }
      }
    };
    fetchPost();
    return () => {
      isMounted = false;
    };
  }, [history, isAdmin]);

  return {
    listFields,
    loadingRequest,
  };
};



export const useObtenerDatosFiltrosPedidos = (code: string) => {
  const [dataOptionSelected, setDataOptionSelected] = useState<any[]>([]);
  const [loadingRequest, setLoadingRequest] = useState<boolean>(false);

  const history = useHistory();

  useEffect(() => {
    let isMounted = true;

    const fetchPost = async () => {
      setLoadingRequest(true);
      try {
        const res = await obtenerDatosFiltrosPedidos(code);
        if (isMounted && res) {
          setDataOptionSelected(res);
        }
      } catch (error) {
        history.push("/error/500");
      } finally {
        if (isMounted) {
          setLoadingRequest(false);
        }
      }
    };

    if (code) {
      fetchPost();
    }

    return () => {
      isMounted = false;
    };
  }, [code, history]);

  return {
    dataOptionSelected,
    loadingRequest,
  };
};

